module.exports = new __parcel__URL__("small-magic-potion.97cd17a4.webp").toString();